import { render, staticRenderFns } from "./EditStudentPage.vue?vue&type=template&id=56e23410&"
import script from "./EditStudentPage.vue?vue&type=script&lang=ts&"
export * from "./EditStudentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports